import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/object-4.png'
import _imports_1 from '../../assets/images/icon-right-red.png'
import _imports_2 from '../../assets/images/icon-up-right-arrow.png'
import _imports_3 from '../../assets/images/shape-4.png'


const _withScopeId = n => (_pushScopeId("data-v-2d186698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-color-161519 pt-100 pb-75 position-relative z-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-sm-flex justify-content-between align-items-center mb-50" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title left-title white-title mb-0 mw-700",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "100"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object mb-4",
    src: _imports_0,
    alt: "object"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "SUCCESS STORIES"),
  /*#__PURE__*/_createElementVNode("h2", null, " Where Tangible Creations and Human Bonds Converge for Lasting Offline Impact ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_6 = { class: "row align-items-center" }
const _hoisted_7 = ["data-aos-delay"]
const _hoisted_8 = { class: "success-single-item style-three transition-y" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "icon-up-right-arrow"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "shape shape-8",
  alt: "shape-4"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/success-stories",
          class: "read-more text-white mt-3 d-inline-block",
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "200"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" VIEW MORE "),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.success, (succes) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-3 col-sm-6",
            key: succes.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": succes.dataDelay
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                to: "/success-story-details",
                class: "d-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: succes.image,
                    alt: "success"
                  }, null, 8, _hoisted_9)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_router_link, {
                to: "/success-story-details",
                class: "success-content d-flex align-items-center justify-content-between"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", null, _toDisplayString(succes.title), 1),
                    _createElementVNode("span", null, _toDisplayString(succes.designation), 1)
                  ]),
                  _hoisted_10
                ]),
                _: 2
              }, 1024)
            ])
          ], 8, _hoisted_7))
        }), 128))
      ])
    ]),
    _hoisted_11
  ]))
}